import CommonSettingWidget from './CommonSettingWidget';
export default CommonSettingWidget;
